export default __webpack_public_path__ + "static/media/good-day-header-harbolnas.5d74bdb6.png";